(() => {
    if (window.__scheduleEventScriptLoaded) {
        return;
    }

    window.__scheduleEventScriptLoaded = true;

    const getTimingSortKey = (timing) => {
        if (timing === '初頭') {
            return 10;
        }

        if (timing === '春') {
            return 20;
        }

        if (timing === '夏') {
            return 30;
        }

        if (timing === '秋') {
            return 40;
        }

        if (timing === '冬') {
            return 50;
        }

        if (!timing || timing === '年') {
            return 60;
        }

        if (timing === '未定') {
            return 90;
        }

        return 70;
    };

    const getGroupMeta = (item) => {
        const year = Number(item.dataset.year || 0);
        const month = Number(item.dataset.month || 0);
        const timing = item.dataset.timing || '';

        if (!year || !month || timing === '未定') {
            return {
                key: 'undecided',
                label: '発売日未定',
                sortKey: Number.MAX_SAFE_INTEGER,
                type: 'undecided',
                year: 0,
                month: 0,
            };
        }

        return {
            key: `month-${year}-${month}`,
            label: `${year}.${month}`,
            sortKey: year * 100 + month,
            type: 'month',
            year,
            month,
        };
    };

    const getPointMeta = (item) => {
        const year = Number(item.dataset.year || 0);
        const month = Number(item.dataset.month || 0);
        const day = Number(item.dataset.day || 0);
        const timing = item.dataset.timing || '';
        const label = item.dataset.label || '未定';

        if (!year) {
            return {
                key: `undecided-${timing || 'unknown'}`,
                label,
                sortKey: Number.MAX_SAFE_INTEGER,
            };
        }

        if (!month) {
            return {
                key: `year-${year}-${timing || 'year'}`,
                label,
                sortKey:
                    year * 100 +
                    getTimingSortKey(timing),
            };
        }

        if (day) {
            return {
                key: `day-${day}`,
                label,
                sortKey: day,
            };
        }

        if (timing === '上旬') {
            return {
                key: 'timing-early',
                label,
                sortKey: 100,
            };
        }

        if (timing === '中旬') {
            return {
                key: 'timing-middle',
                label,
                sortKey: 200,
            };
        }

        if (timing === '下旬') {
            return {
                key: 'timing-late',
                label,
                sortKey: 300,
            };
        }

        if (timing === '未定') {
            return {
                key: `month-${year}-${month}-undecided`,
                label,
                sortKey: 900,
            };
        }

        return {
            key: `timing-${timing || 'month'}`,
            label,
            sortKey: 400,
        };
    };

    const compareScheduleItems = (a, b) => {
        const groupA = getGroupMeta(a);
        const groupB = getGroupMeta(b);

        if (groupA.sortKey !== groupB.sortKey) {
            return groupA.sortKey - groupB.sortKey;
        }

        const pointA = getPointMeta(a);
        const pointB = getPointMeta(b);

        return pointA.sortKey - pointB.sortKey;
    };

    const filterScheduleItems = (root, items) => {
        const currentYear = Number(
            root.dataset.currentYear
        );

        const currentMonth = Number(
            root.dataset.currentMonth
        );

        return items.filter((item) => {
            const year = Number(
                item.dataset.year || 0
            );

            const month = Number(
                item.dataset.month || 0
            );

            if (!year || !month) {
                return true;
            }

            if (year > currentYear) {
                return true;
            }

            if (year < currentYear) {
                return false;
            }

            return month >= currentMonth;
        });
    };

    const buildGroups = (items) => {
        const groups = [];

        let currentGroup = null;
        let currentPoint = null;

        items.forEach((item) => {
            const groupMeta = getGroupMeta(item);
            const pointMeta = getPointMeta(item);

            if (!currentGroup || currentGroup.key !== groupMeta.key) {
                currentGroup = {
                    ...groupMeta,
                    points: [],
                };

                groups.push(currentGroup);
                currentPoint = null;
            }

            if (!currentPoint || currentPoint.key !== pointMeta.key) {
                currentPoint = {
                    ...pointMeta,
                    items: [],
                };

                currentGroup.points.push(currentPoint);
            }

            currentPoint.items.push(item);
        });

        return groups;
    };

    const sanitizeId = (value) => {
        return String(value).replace(
            /[^a-zA-Z0-9_-]/g,
            '-'
        );
    };

    const getGroupElementId = (root, group) => {
        const sectionId = sanitizeId(
            root.dataset.sectionId || 'schedule'
        );

        return `${sectionId}-schedule-${group.key}`;
    };

    const createTimelinePoint = (point) => {
        const item = document.createElement('li');

        item.className =
            'tw-relative tw-pb-6 tw-ml-5 last:tw-mb-0';

        const marker = document.createElement('div');

        marker.className =
            'tw-absolute tw-mt-6 tw-h-3 tw-w-3 tw-rounded-full tw-border tw-border-solid tw-border-gray-300 tw-bg-white';

        marker.style.left = '-26px';
        marker.setAttribute('aria-hidden', 'true');

        const time = document.createElement('time');

        time.className =
            'tw-block tw-pt-5 tw-text-sm tw-font-normal tw-leading-none tw-text-gray-500';

        time.textContent = point.label;

        const events = document.createElement('div');

        events.className =
            'tw-mt-2 tw-space-y-1';

        point.items.forEach((scheduleItem) => {
            const content = scheduleItem.querySelector(
                '[data-schedule-event-content]'
            );

            if (content) {
                events.append(content);
            }
        });

        item.append(
            marker,
            time,
            events
        );

        return item;
    };

    const createTimelineGroup = (root, group) => {
        const section = document.createElement('section');

        section.id = getGroupElementId(
            root,
            group
        );

        section.className =
            'tw-mt-8 first:tw-mt-0';

        section.dataset.scheduleGroup =
            group.key;

        const heading =
            document.createElement('h2');

        heading.className =
            'tw-m-0 tw-border-0 tw-border-b tw-border-solid tw-border-gray-300 tw-pl-2 tw-pb-1 tw-text-left tw-text-2xl tw-font-bold tw-leading-tight';

        heading.textContent = group.label;

        const timeline =
            document.createElement('ol');

        timeline.className =
            'tw-relative !tw-ml-4 tw-list-none tw-border-0 tw-border-l tw-border-solid tw-border-gray-300 tw-p-0 tw-pt-6';

        timeline.dataset.scheduleTimeline = '';

        group.points.forEach((point) => {
            timeline.append(
                createTimelinePoint(point)
            );
        });

        section.append(
            heading,
            timeline
        );

        return section;
    };

    const setActiveNavButton = (
        navList,
        groupKey
    ) => {
        navList
            .querySelectorAll(
                '[data-schedule-nav-button]'
            )
            .forEach((button) => {
                const isActive =
                    !button.disabled &&
                    button.dataset.scheduleNavButton ===
                    groupKey;

                button.classList.toggle(
                    'is-active',
                    isActive
                );

                if (isActive) {
                    button.setAttribute(
                        'aria-current',
                        'true'
                    );
                } else {
                    button.removeAttribute(
                        'aria-current'
                    );
                }
            });
    };

    const getNavigationGroups = (root) => {
        const currentYear = Number(
            root.dataset.currentYear
        );

        const currentMonth = Number(
            root.dataset.currentMonth
        );

        const groups = [];

        for (
            let index = 0;
            index < 9;
            index += 1
        ) {
            const zeroBasedMonth =
                currentMonth - 1 + index;

            const year =
                currentYear +
                Math.floor(
                    zeroBasedMonth / 12
                );

            const month =
                zeroBasedMonth % 12 + 1;

            groups.push({
                key: `month-${year}-${month}`,
                label: `${month}月`,
                year,
                month,
            });
        }

        groups.push({
            key: 'undecided',
            label: '未定',
            year: 0,
            month: 0,
        });

        return groups;
    };

    const createNavigationSeparator = (
        index
    ) => {
        const separator =
            document.createElement('span');

        separator.className =
            'tw-flex-shrink-0 tw-text-gray-300';

        if (index === 4) {
            separator.className +=
                ' schedule-nav-separator--sp-row-end';
        }

        separator.textContent = '|';

        separator.setAttribute(
            'aria-hidden',
            'true'
        );

        return separator;
    };

    const renderNavigation = (
        root,
        scheduleGroups
    ) => {
        const nav = root.querySelector(
            '[data-schedule-nav]'
        );

        const navList = root.querySelector(
            '[data-schedule-nav-list]'
        );

        if (!nav || !navList) {
            return;
        }

        const navigationGroups =
            getNavigationGroups(root);

        const availableGroupKeys =
            new Set(
                scheduleGroups.map(
                    (group) => group.key
                )
            );

        const fragment =
            document.createDocumentFragment();

        navigationGroups.forEach(
            (group, index) => {
                const hasSchedule =
                    availableGroupKeys.has(
                        group.key
                    );

                const item =
                    document.createElement('li');

                item.className =
                    'tw-flex tw-min-w-0 tw-items-center tw-justify-center';

                const button =
                    document.createElement('button');

                button.type = 'button';

                button.dataset.scheduleNavButton =
                    group.key;

                button.textContent =
                    group.label;

                if (hasSchedule) {
                    button.className =
                        'tw-flex-1 tw-cursor-pointer tw-whitespace-nowrap tw-border-0 tw-bg-white tw-px-1 tw-py-0.5 tw-mx-1 tw-text-sm tw-font-semibold tw-text-gray-700 tw-rounded';

                    const targetId =
                        getGroupElementId(
                            root,
                            group
                        );

                    button.setAttribute(
                        'aria-controls',
                        targetId
                    );

                    button.setAttribute(
                        'aria-label',
                        `${group.label}へ移動`
                    );

                    button.addEventListener(
                        'click',
                        () => {
                            const target =
                                document.getElementById(
                                    targetId
                                );

                            if (!target) {
                                return;
                            }

                            setActiveNavButton(
                                navList,
                                group.key
                            );

                            target.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            });
                        }
                    );
                } else {
                    button.className =
                        'tw-flex-1 tw-cursor-not-allowed tw-whitespace-nowrap tw-border-0 tw-bg-white tw-px-1 tw-py-2 tw-text-sm tw-font-semibold tw-text-gray-300';

                    button.disabled = true;

                    button.setAttribute(
                        'aria-label',
                        `${group.label}のスケジュールはありません`
                    );
                }

                item.append(button);

                if (
                    index <
                    navigationGroups.length - 1
                ) {
                    item.append(
                        createNavigationSeparator(
                            index
                        )
                    );
                }

                fragment.append(item);
            }
        );

        navList.replaceChildren(
            fragment
        );

        const firstAvailableGroup =
            navigationGroups.find(
                (group) =>
                    availableGroupKeys.has(
                        group.key
                    )
            );

        if (firstAvailableGroup) {
            setActiveNavButton(
                navList,
                firstAvailableGroup.key
            );
        }

        nav.hidden = false;
    };

    const renderSchedule = (root) => {
        const list = root.querySelector(
            '[data-schedule-list]'
        );

        const itemsContainer =
            root.querySelector(
                '[data-schedule-items]'
            );

        const empty = root.querySelector(
            '[data-schedule-empty]'
        );

        if (!list || !itemsContainer) {
            return;
        }

        const allItems = Array.from(
            itemsContainer.querySelectorAll(
                '[data-schedule-item]'
            )
        );

        const items = filterScheduleItems(
            root,
            allItems
        );

        if (items.length === 0) {
            list.replaceChildren();

            if (empty) {
                empty.hidden = false;
            }

            renderNavigation(
                root,
                []
            );

            return;
        }

        if (empty) {
            empty.hidden = true;
        }

        items.sort(
            compareScheduleItems
        );

        const groups =
            buildGroups(items);

        const fragment =
            document.createDocumentFragment();

        groups.forEach((group) => {
            fragment.append(
                createTimelineGroup(
                    root,
                    group
                )
            );
        });

        list.replaceChildren(fragment);

        renderNavigation(
            root,
            groups
        );
    };

    const fetchSchedulePage = async (
        root,
        page
    ) => {
        const sectionId =
            root.dataset.sectionId;

        const pageParam =
            root.dataset.pageParam ||
            'page';

        if (!sectionId) {
            return [];
        }

        const url = new URL(
            window.location.href
        );

        url.searchParams.set(
            pageParam,
            String(page)
        );

        url.searchParams.set(
            'section_id',
            sectionId
        );

        const response =
            await fetch(
                url.toString()
            );

        if (!response.ok) {
            throw new Error(
                `Failed to load schedule page: ${response.status}`
            );
        }

        const html =
            await response.text();

        const documentHtml =
            new DOMParser()
                .parseFromString(
                    html,
                    'text/html'
                );

        return Array.from(
            documentHtml.querySelectorAll(
                '[data-schedule-item]'
            )
        );
    };

    const initSchedule = async (
        root
    ) => {
        if (
            root.dataset
                .scheduleInitialized ===
            'true'
        ) {
            return;
        }

        root.dataset
            .scheduleInitialized =
            'true';

        const itemsContainer =
            root.querySelector(
                '[data-schedule-items]'
            );

        const loading =
            root.querySelector(
                '[data-schedule-loading]'
            );

        const pagination =
            root.querySelector(
                '[data-schedule-pagination]'
            );

        if (!itemsContainer) {
            return;
        }

        const totalPages = Number(
            root.dataset.totalPages || 1
        );

        const currentPage = Number(
            root.dataset.currentPage || 1
        );

        if (
            totalPages > 1 &&
            loading
        ) {
            loading.hidden = false;
        }

        try {
            for (
                let page = 1;
                page <= totalPages;
                page += 1
            ) {
                if (
                    page === currentPage
                ) {
                    continue;
                }

                const items =
                    await fetchSchedulePage(
                        root,
                        page
                    );

                items.forEach(
                    (item) => {
                        itemsContainer.append(
                            item
                        );
                    }
                );
            }

            renderSchedule(root);

            if (loading) {
                loading.hidden = true;
            }
        } catch (error) {
            console.error(error);

            renderSchedule(root);

            if (loading) {
                loading.textContent =
                    '一部のスケジュールを取得できませんでした。';

                loading.hidden = false;
            }

            if (pagination) {
                pagination.hidden = false;
            }
        }
    };

    const initSchedules = (
        container = document
    ) => {
        container
            .querySelectorAll(
                '[data-schedule]'
            )
            .forEach(
                initSchedule
            );
    };

    initSchedules();

    document.addEventListener(
        'shopify:section:load',
        (event) => {
            initSchedules(
                event.target
            );
        }
    );
})();